import { Skeleton, Stack } from "@mui/material";

import { useSubCategoryRatings } from "./hooks/useSubCategoryRatings";
import { SubCategoryRatingBar } from "./SubCategoryRatingBar";

interface SubCategoryRatingsProps {
  workplaceId: string;
}

function SubCategoryRatingsSkeleton() {
  return (
    <Stack spacing={5}>
      {Array.from({ length: 4 }, (_, index) => (
        <Stack key={index} spacing={1}>
          <Skeleton variant="rectangular" height={20} width="40%" />
          <Skeleton variant="rectangular" height={6} />
        </Stack>
      ))}
    </Stack>
  );
}

export function SubCategoryRatings(props: SubCategoryRatingsProps) {
  const { workplaceId } = props;
  const { subCategoryRatings, isLoading } = useSubCategoryRatings({ workplaceId });

  if (isLoading) {
    return <SubCategoryRatingsSkeleton />;
  }

  if (subCategoryRatings.length === 0) {
    return null;
  }

  return (
    <Stack spacing={5}>
      {subCategoryRatings.map((subCategory) => (
        <SubCategoryRatingBar
          key={subCategory.tag}
          label={subCategory.label}
          rating={subCategory.averageRating}
          ratingsCount={subCategory.ratingsCount}
        />
      ))}
    </Stack>
  );
}
